export const all = () => {
    return [
        {
            key: "CURATOR",
            value: 1,
        },
        {
            key: "RESPONSIBLE",
            value: 2,
        },
        {
            key: 'EXECUTOR',
            value: 3,
        },
        {
            key: 'SIGNER',
            value: 4,
        },
        {
            key: 'DIRECTOR_SIGNER',
            value: 5,
        },
        {
            key: 'CLOSING_SIGNER',
            value: 6,
        },
        {
            key: 'ACCOUNTANT',
            value: 7,
        },
        {
            key: 'TO_RESOLUTION',
            value: 21,
        },
    ]
}

export const getValueByKey = (key) => {
    return all().find(item => item.key === key)?.value
}

export default {
    all,
    getValueByKey
};
